export const CAD_PLAN_ID = {
    PRO_COMPANY_TRIAL: 'PRO_COMPANY_TRIAL',
    FREE_2016: 'FREE_2016',
    PRO_DISCOVERY: 'PRO_DISCOVERY',
    EDU_YEARLY: 'EDU_YEARLY',
    EDU_EDUCATOR: 'EDU_EDUCATOR',
    STANDARD: 'STANDARD_YEARLY',
};
export const CAM_APP_PLAN_ID_MAP = {
    CAM: {
        CAM_STUDIO_EDU: 'CAM_STUDIO_EDU',
    },
};
